<template>
	<div>
		<a-modal :title="'睡眠报告'" :visible="isShowAlert" :maskClosable="false"
			@cancel="isShowAlert = false"
			:dialog-style="{ 'min-width': '1000px', 'max-width': '1000px', 'border-radius': '16px', 'background': '#FFFFFF00', 'overflow': 'hidden', 'min-height': '802px', 'max-height': '802px' }"
			:footer="null" id="old" :zIndex="1000">
			<div class="needGZ_TanWrap" v-if="isShowAlert">
				<div class="needGZ_Tan"
					style="width: 1000px;height: 802px; display: flex; flex-direction: column; padding-bottom: 25px; background: #ECF0F3; position: relative;">

					<div v-if="loading"
						style="width:1000px;height:862px;position: fixed;background:#FFFFFF00;z-index: 999999;display:flex;justify-content: center;align-items: center;">
						<a-spin :allSpinning="loading" tip="加载中" :delay="100" size="large"></a-spin>
					</div>

					<div style="display: flex; height: 65px; position: relative;">
						<img style="position: absolute; width: 100%; height: 65px;"
							src="../../../assets/icon_dean_home_alert_bg_2.png" alt="">
						<div
							style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; justify-content: space-between; align-items: center;">
							<div style="display: flex; align-items: center; height: 100%;">
								<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px;">
								</div>
								<div
									style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 20px;">
									状态优秀的长者</div>
								<div style="display: flex; align-items: center; margin-left: 5px;">
									<img style="width: 7px; height: 8px; z-index: 1;"
										src="../../../assets/icon_common_special_arrow_0.png" alt="" />
									<div
										style="margin-left: -2px; background: #E0F5F0; border-radius: 4px; border: 1px solid #B6EBDF; padding: 2px 5px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #35C0A0; line-height: 20px;">
										{{ (data && data.stateExcellentElderVoPage && data.stateExcellentElderVoPage.total) ? (data && data.stateExcellentElderVoPage && data.stateExcellentElderVoPage.total) + '位' : '0位'  }}</div>
								</div>
							</div>
							<img style="width: 36px; height: 36px; margin-right: 15px; cursor: pointer;"
								src="../../../assets/icon_common_close_1.png" alt=""
								@click="isShowAlert = false" />
						</div>
					</div>

					<div class="needGZ_Cont" style="flex: 1; display: flex; flex-direction: column; background: #ECF0F3;">
						<div style="flex: 1;">
							<div style="width: 100%; display: flex; flex-wrap: wrap;"
								v-if="data && data.stateExcellentElderVoPage && data.stateExcellentElderVoPage.records">
								<div class="miniCardHover" v-for="(subItem, subIndex) in data.stateExcellentElderVoPage.records"
									style="width: 223px; height: 199px; box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF; border-radius: 16px; display: flex; flex-direction: column; margin-top: 20px;"
									:style="{ marginRight: (subIndex + 1) % 4 == 0 ? '0px' : '19px' }"
									@click="miniCardClick(subItem)">
									<div style="flex: 1; display: flex; position: relative; justify-content: center;">
										<div
											style="flex: 1; margin-bottom: 10px; margin-left: 5px; margin-right: 5px; margin-top: 5px; background: #F3F9F9; border-radius: 12px; border: 1px solid #B6EBDF; display: flex; flex-direction: column;">
											<div class="richTextDiv"
												style="flex: 1; display: flex; flex-direction: column; padding-left: 10px; padding-right: 10px;">
												<div 
													class="description"
													v-if="miniIndex <= 1" 
													v-for="(miniItem, miniIndex) in subItem.stateExcellentTextList || []" 
													style="background: #E0F5F0; border-radius: 8px; height: 40px; margin-top: 10px; display: flex; align-items: center; position: relative;"
													>
														<div v-html="$options.filters.reMate(miniItem)" style="width: 170px; margin-left: 10px;"></div>
														<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: 30px; padding: 10px; border-radius: 8px; display: none;" :style="{left: (subIndex == 3 || subIndex == 7 || subIndex == 11)  ? '-50%' : '50%'}">
															<div v-html="$options.filters.reMate(miniItem)"></div>
														</div>
													</div>
											</div>
											<div
												style="display: flex; height: 34px; justify-content: space-between; margin-bottom: 10px; padding-left: 10px; padding-right: 10px;">
												<div style="width: 38px; height: 24px; background: rgba(94, 103, 121, 0.1); border-radius: 19px 19px 19px 2px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; display: flex; align-items: center; padding-left: 8px;"
													:style="{ opacity: subItem && subItem.stateExcellentList && subItem.stateExcellentList.length > 2 ? 1 : 0 }">
													…</div>
												<div
													style="width: 58px; height: 30px; background: rgba(74, 124, 232, 0.15); border-radius: 20px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 20px; display: flex; justify-content: center; align-items: center; align-self: flex-end;">
													查看</div>
											</div>
										</div>
										<img style="position: absolute; width: 16px; height: 12px; bottom: 0px;"
											src="../../../assets/icon_common_special_arrow_3.png" alt="" />
									</div>
									<div
										class="bedName"
										style="display: flex; margin-bottom: 10px; align-items: center; justify-content: center; position: relative;">
										<div class="miniCardHoverImg" style="width: 20px; height: 20px; margin-right: 5px;"
											alt=""></div>
										<div class="miniCardHoverText"
											style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 175px;">
											{{ subItem.bedName || '' }}</div>
										<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: -40px; padding: 10px; border-radius: 8px; display: none; z-index: 10000;" :style="{ left: (subIndex == 3 || subIndex == 7 || subIndex == 11) ? '-50%' : '50%'}">
											<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; color: rgba(94, 103, 121, 1);">{{ subItem.bedName || '' }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div style="background-color: #ECF0F3;"
						v-if="data && data.stateExcellentElderVoPage && data.stateExcellentElderVoPage.total">
						<a-pagination @change="changePage" :total="data.stateExcellentElderVoPage.total" :pageSize="pageSize"
							:hideOnSinglePage="true" show-less-items style="text-align: center;" />
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>
  
<script>
import QlBtn from '../../../component/common/qlBtn.vue'
import * as ExportPdfManager from '../../../utils/ExportPdfManager';
import WorkProposalAlert from './workProposalAlert.vue'
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

import thirdCardMockListData from '../thirdCardMockListData.json'

export default {
	components: { QlBtn, WorkProposalAlert },
	filters: {
		reMate(val) {
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {

	},
	watch: {

	},
	data() {
		return {
			isShowAlert: false,
			pageNum: 1,
			pageSize: 12,
			data: null,
			loading: false
		};
	},
	created() { },
	mounted() {


	},
	methods: {

		openAlert() {
			this.isShowAlert = true;
			this.data = null;
			this.pageNum = 1;
			this.getListData();
		},
		miniCardClick(item) {
			this.$emit('itemClick', item);
		},
		// 状态优秀的长者 - 全部
		getListData() {
			this.loading = true;
			this.$get(
				'api/dean/v5/stateExcellentElderPage',
				{
					pageNum: this.pageNum,
					pageSize: this.pageSize
				},
				(res) => {
					// res = thirdCardMockListData;
					this.loading = false;
					if (res.code == 0) {
						if (res.data) {
							this.data = res.data;
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					this.loading = false;
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		changePage(e) {
			this.pageNum = e;
			this.getListData();
		},
	},
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.miniCardHover {
	background: #ECF0F3;
	cursor: pointer;
	.miniCardHoverText {
		color: #5E6779;
	}

	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_6.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.miniCardHover:hover {
	background: #DFE8FC;

	.miniCardHoverText {
		color: #4A7CE8;
	}

	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_7.png') no-repeat no-repeat;
		background-size: contain;
	}
}


::v-deep .ant-pagination-item {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #ECF0F3;
}

::v-deep .ant-pagination-item:hover {
	background: #DFE8FC;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #DFE8FC;
}

::v-deep .ant-pagination-item-active {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid rgba(74, 124, 232, 0.5);
}

::v-deep .ant-pagination-item-link {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 0px solid #ECF0F3;
}

::v-deep .ant-pagination-item-link:hover {
	background: #DFE8FC;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #DFE8FC;
}

::v-deep .ant-pagination-disabled .ant-pagination-item-link {
	background: #ECF0F3;
	border-radius: 10px;
	border: 1px solid rgba(202, 205, 217, 0.5);
	box-shadow: unset;
}

.richTextDiv ::v-deep {
	.richContentStyle {
		display: block;
		white-space: nowrap;
		height: 20px;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}

	.richTextStyleGreen {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(53, 192, 160, 1);
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}
}

.description:hover {
	.showDescription {
		display: block !important;
	}
}

.bedName:hover {
	.showDescription {
		display: block !important;
	}
}

</style>
  